import { ICommonSettings, INotifyActionsDefaultDurationSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigNotifyActionsDefaultDurationSettings } from "./app-settings-config-notify-action-duration";

export interface IConfigNotifyActionDurationInputState {
  showModal: boolean;
  editingNotifyActionDurationId: string;
}

export interface IConfigNotifyActionDurationInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigNotifyActionDurationInput extends PureComponent<
  IConfigNotifyActionDurationInputProps,
  IConfigNotifyActionDurationInputState
> {
  formInputName = ["apiConfig", "notifyActionsDefaultDurationSettingsId"];

  constructor(props: IConfigNotifyActionDurationInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingNotifyActionDurationId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingNotifyActionDurationId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingNotifyActionDurationId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [
      { id: null, name: "Default" } as unknown as INotifyActionsDefaultDurationSettings,
      ...(commonSettings.notifyActionsDurationsSettings || [])
    ];
    return (
      <>
        <ConfigNotifyActionsDefaultDurationSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingNotifyActionDurationId={this.state.editingNotifyActionDurationId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <div style={{ marginTop: 16 }}>
          <ConfigSettingSelect
            label="Default Durations"
            formInputName={this.formInputName}
            options={options}
            allowClear
            tooltipContentKey="appsettings_notifyactions_defaultdurations"
            onAddNew={this.openModal}
            onEdit={this.setEditingSetting}
            parentConfigValue={this.props.parentConfigValue}
            onRestore={this.handleRestore}
            dropdownTestId="appSettingsNotifyActionsDropdown"
            addNewTestId="appSettingsNotifyActionsAddNewButton"
            editTestId="appSettingsNotifyActionsEditButton"
          />
        </div>
      </>
    );
  }
}
